<template>
  <fragment>
    <div class="cover" v-if="dropdown" @click="dropdown = false"></div>
    <div class="HeaderBar" :style="customStyle || {}">
      <router-link
        class="title"
        tag="div"
        :to="{ name: 'narrative', query: $route.query }"
      >
        <div>12 Sunsets</div>
      </router-link>
      <div class="subtitle">Exploring<br />Ed Ruscha's<br />Archive</div>
      <div class="menu" @click="dropdown = !dropdown">
        <img :src="menuPath" v-if="!dropdown" />
        <img :src="xPath" v-else />
        <div :class="{ navigation: true, dropdown }">
          <div :class="{ drive: true, active: $route.name === 'map' }">
            <router-link
              :to="{
                name: 'map',
                params: { year: '1985' },
                query: $route.query
              }"
              >Drive</router-link
            >
          </div>
          <div :class="{ sort: true, active: $route.name === 'contact-sheet' }">
            <router-link :to="{ name: 'contact-sheet', query: $route.query }"
              >Sort</router-link
            >
          </div>
          <div :class="{ about: true, active: $route.name === 'about' }">
            <router-link :to="{ name: 'about', query: $route.query }">
              About</router-link
            >
          </div>
          <div
            class="share"
            @click="$store.commit('setShare', !$store.state.ui.share)"
          >
            Share
          </div>
          <Footer />
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Footer from "../components/Footer";
import { getAssetPath } from "@/constants/constants";

export default {
  name: "HeaderBar",
  components: { Footer },
  props: { customStyle: null },
  data() {
    return {
      dropdown: false
    };
  },
  computed: {
    menuPath() {
      return getAssetPath("/assets/menu.svg");
    },

    xPath() {
      return getAssetPath("/assets/thin-x.svg");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.cover {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 10;
}

.HeaderBar {
  width: 100%;
  display: flex;
  height: 67px;
  background-color: $very-light-pink;
  align-items: center;
  position: relative;
  justify-content: flex-start;

  @media (orientation: landscape) and (max-width: 815px) {
    display: none;
  }
}

.title {
  font-family: "Graphik";
  font-style: italic;
  font-size: 22px;
  font-weight: 600;
  background-color: $copper;
  color: $very-light-pink;
  text-transform: uppercase;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  position: relative;
  margin-right: 1em;
  min-width: 140px;

  &:hover {
    // background-color: $light-gold;
    // color: $copper;
    cursor: pointer;
    color: $light-gold;
  }

  div {
    z-index: 2;
  }
}

.menu {
  width: 50px;
  margin-right: 10px;
}

.title:after {
  cursor: pointer;
  background: inherit;
  content: "";
  width: 40px;
  height: 100%;
  right: -10px;
  bottom: 0;
  display: block;
  position: absolute;
  transform-origin: 100%;
  transform: skewX(-10deg);
  z-index: 1;
}

.subtitle {
  text-transform: uppercase;
  font-size: 15px;
  width: 100px;
  text-align: left;
  font-weight: 300;
  flex-grow: 1;
}

.navigation {
  flex-grow: 1;
  display: none;
  width: 200px;

  &.dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 67px;
    z-index: 1000;
    background-color: $very-light-pink;
    right: 0px;
  }

  div {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    &.share {
      color: $copper;
      font-weight: 700;
      font-style: italic;
      font-size: 23px;
      margin-top: -2px;
    }
  }

  .active {
    font-weight: 500;
    text-decoration: underline;
  }
}

a {
  color: inherit;
  text-decoration: inherit;
}
</style>

<style lang="scss">
#footer {
  width: auto !important;
  font-size: 12px !important;
  height: auto !important;
  padding: 0.5em !important;
  text-transform: initial !important;
}
</style>
